/**
 * Hook to access ruleset context from RulesetLayout
 */
import { createContext, useContext } from 'react';
import type { UseUrlRulesetResult } from '../../hooks/useUrlRuleset';

/**
 * Context for ruleset data - allows child components to access
 * ruleset info without needing useParams
 */
export const RulesetContext = createContext<UseUrlRulesetResult | null>(null);

/**
 * Hook to access ruleset context (for components that don't want to use useUrlRuleset directly)
 */
export function useRulesetContext() {
  const context = useContext(RulesetContext);
  if (!context) {
    throw new Error('useRulesetContext must be used within a RulesetLayout');
  }
  return context;
}
